import { render, staticRenderFns } from "./BrandTrackingSettings.vue?vue&type=template&id=42176ba8"
import script from "./BrandTrackingSettings.vue?vue&type=script&lang=js"
export * from "./BrandTrackingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports